import { useEffect, useRef } from "react";
import { Chart } from "chart.js";

interface Props {
    chartRef: React.MutableRefObject<Chart<"doughnut" | "bar" | "line", unknown[], unknown> | Element | HTMLCanvasElement | undefined>;
    animationDuration: number;
    threshold: number;
    render: () => void;
}

const useChartJsIntersectionObserver = ({ chartRef, animationDuration, threshold, render }: Props) => {
    const hasRenderedRef = useRef(false);

    useEffect(() => {
        const chartElement = chartRef.current;

        const observerCallback = (entries: IntersectionObserverEntry[]) => {
            if (entries[0].isIntersecting) {
                render();
                hasRenderedRef.current = true;
            }
        };

        const observerOptions = {
            threshold,
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        if (chartElement) {
            observer.observe(chartElement as Element);
        }

        // Clean up the observer when the component is unmounted
        return () => {
            if (chartElement) {
                observer.unobserve(chartElement as Element);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chartRef, animationDuration, threshold]);

    return { hasRenderedRef };
};

export default useChartJsIntersectionObserver;
